import React from 'react';
import { css } from 'aphrodite';
import styles from './dropdown-styles';
import { FaAngleDown } from 'react-icons/fa';

const DropdownView = (props) => (
  <div className={css(styles.root)} ref={props.setRef}>

    <button className={css(styles.dropdownButton)} onClick={props.toggleDropdown}>
      <div>{props.selectedOption}</div>
      <div style={{flex: 1}} />
      <FaAngleDown className={css(styles.sortIcon, props.dropdownOpen && styles.sortIconExpanded)} />
    </button>

    {props.dropdownOpen && <div className={css(styles.optionsContainer)}>
      {props.options.map((option, index) => (
        <div key={index} className={css(styles.option)} onClick={() => props.onClickOption(option)}>
          {option.name}
        </div>
      ))}
    </div>}

  </div>
);

export default DropdownView;





// WEBPACK FOOTER //
// ./src/components/common/dropdown/dropdown-view.js